import { PlayerOptions } from './VideoPlayer.types'

/** A seek landing this close to the start counts as replaying from the beginning. */
export const RESTART_POSITION_SECONDS = 1

/** Slack, in seconds, for timer jitter when deciding how much content one sample may credit. */
export const WATCH_CREDIT_SLACK_SECONDS = 0.5

export const defaultVideoOptions: PlayerOptions = {
  autoplay: false,
  controls: true,
  playbackRates: [0.75, 1, 1.25, 1.5, 2],
  disablePictureInPicture: false,
  loop: false,
  muted: false,
  preload: 'none',
  height: 720,
  width: 1280,
  poster: '',
  textTrackSettings: false,
  controlBar: {
    skipButtons: {
      backward: 10,
      forward: 10,
    },
    progressControl: {
      seekBar: {
        loadProgressBar: false,
        mouseTimeDisplay: false,
        playProgressBar: true,
      },
    },
  },
  responsive: true,
  fluid: true,
  sources: [
    {
      src: '',
      type: 'video/mp4',
    },
  ],
}

/** Fastest a viewer can play content — the ceiling on how much a second of real time can cover. */
export const MAX_PLAYBACK_RATE = Math.max(...(defaultVideoOptions.playbackRates ?? [1]))
